const STORAGE_KEY = 'recent-users';
const MAX_RECENT_USERS = 5;

export const getRecentUsers = () => {
  try {
    const users = JSON.parse(window.localStorage.getItem(STORAGE_KEY));
    return Array.isArray(users) ? users : [];
  } catch (error) {
    return [];
  }
};

export const addRecentUser = ({ userId, firstName, lastName, email }) => {
  if (!userId) return;

  try {
    const name = [firstName, lastName].filter(Boolean).join(' ');
    const otherUsers = getRecentUsers().filter((user) => user.userId !== userId);
    const users = [{ userId, name, email, viewedAt: Date.now() }, ...otherUsers].slice(0, MAX_RECENT_USERS);
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(users));
  } catch (error) {
    // The app still works if storage is unavailable, the list just stays empty
  }
};

export const clearRecentUsers = () => {
  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    // Nothing to clear if storage is unavailable
  }
};
